export default __webpack_public_path__ + "static/media/NewYearResolution_17.b36bf47b.png";